"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullVideoWarning = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

require("./FullVideoWarning.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var FullVideoWarning = function FullVideoWarning(_ref) {
  var _ref$marginTop = _ref.marginTop,
      marginTop = _ref$marginTop === void 0 ? 0 : _ref$marginTop,
      expirationDays = _ref.expirationDays;
  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    marginTop: marginTop
  }, /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "download-expire-warning",
    type: _atoms.Label.Type.Body,
    color: _atoms.Color.Black,
    spacing: "4",
    content: /*#__PURE__*/_react.default.createElement(_atoms.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_atoms.Label, null, /*#__PURE__*/_react.default.createElement("b", null, "Warning:\xA0"), "This full game download will expire in", /*#__PURE__*/_react.default.createElement("b", null, "\xA0", expirationDays, "\xA0days.\xA0"), "You will still be able to watch the game and download all individual moments as long as you have a Trace subscription."))
  }));
};

exports.FullVideoWarning = FullVideoWarning;